import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import SectionHeading from "../SectionHeading";
import SectionSubheading from "../SectionSubheading";
import AboutUsDescription from "../AboutUsDescription";
import Button from "../ui/Button";
import { useInternationalizedItems } from "../../custom-hooks/useInternationalizedItems";
import { HeadingVariant } from "../../types/constants";
import { ButtonVariant } from "../../types/constants";

export default function EdicationLeftPanel() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const paragraphs = useInternationalizedItems<string[]>({
        key: "home.paragraphs.educationDescription",
    });

    return (
        <div className="flex flex-col items-start w-full md:w-[630px] lap:w-[458px] xl:w-[582px] lg:w-[630px]">
            <div className="w-full max-w-[630px] mb-4 xl:mb-6">
                <SectionHeading text={t("home.headings.materials")} variant={HeadingVariant.DARK} />
            </div>

            <div className="flex flex-col gap-[24px] md:gap-[24px] w-full">
                <SectionSubheading text={t("home.subheadings.materials")} />
                <AboutUsDescription paragraphs={paragraphs} />
            </div>

            <div className="mt-[164px] hidden lap:block">
                <Button
                    text={t("buttons.moreMaterials")}
                    variant={ButtonVariant.PRIMARY}
                    onClick={() => navigate("/educational-materials")}
                />
            </div>
        </div>
    );
}
